import { render, staticRenderFns } from "./AddressProjectAddress.vue?vue&type=template&id=36fe4b58&scoped=true&lang=pug&"
import script from "./AddressProjectAddress.vue?vue&type=script&lang=ts&"
export * from "./AddressProjectAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe4b58",
  null
  
)

export default component.exports